import React from 'react';

const EditingScissors = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Editing" fill="none" fillRule="evenodd">
      <g id="trimming" transform="rotate(90 9 10)">
        <path
          d="M13.5296455,0.947368421 L9.15767372,6.67916531 L4.78570193,0.947368421 C4.78570193,0.947368421 2.85857319,2.27123438 4.23920545,4.17150417 L7.70034979,8.64947049 L5.3321984,11.6944876 L7.15385332,12.9483182 L9.15767372,10.440657 L11.1614941,12.9483182 L12.8009835,11.8736062 L10.4328322,8.64947049 L14.076142,3.63414821 C14.076142,3.63414821 14.9869694,2.02208034 13.5296455,0.947368421 Z"
          id="Shape"
          fill={color}
          fillRule="nonzero"
        />
        <path
          d="M4.89497428,11.1020182 C3.23793405,11.1020182 1.89473684,12.4453972 1.89473684,14.1022556 C1.89473684,15.759114 3.23793405,17.1024931 4.89497428,17.1024931 C6.55201451,17.1024931 7.89521171,15.759114 7.89521171,14.1022556 C7.89521171,12.4453972 6.55201451,11.1020182 4.89497428,11.1020182 Z M4.89497428,15.8296651 C3.94089877,15.8296651 3.16756485,15.0563311 3.16756485,14.1022556 C3.16756485,13.1481801 3.94089877,12.3748462 4.89497428,12.3748462 C5.84904978,12.3748462 6.62238371,13.1481801 6.62238371,14.1022556 C6.62238371,15.0563311 5.84904978,15.8296651 4.89497428,15.8296651 Z"
          id="Shape"
          fill={color}
          fillRule="nonzero"
        />
        <path
          d="M13.2033241,11.1020182 C11.5462839,11.1020182 10.2030867,12.4453972 10.2030867,14.1022556 C10.2030867,15.759114 11.5462839,17.1024931 13.2033241,17.1024931 C14.8603643,17.1024931 16.2035615,15.759114 16.2035615,14.1022556 C16.2035615,12.4453972 14.8603643,11.1020182 13.2033241,11.1020182 Z M13.2033241,15.8296651 C12.2494304,15.8296651 11.4759147,15.0563311 11.4759147,14.1022556 C11.4759147,13.1481801 12.2494304,12.3748462 13.2033241,12.3748462 C14.1572178,12.3748462 14.9307335,13.1481801 14.9307335,14.1022556 C14.9307335,15.0563311 14.1572178,15.8296651 13.2033241,15.8296651 Z"
          id="Shape"
          fill={color}
          fillRule="nonzero"
        />
        <rect
          id="Rectangle-13"
          x="0.274"
          y="0.274"
          width="17.053"
          height="17.053"
        />
      </g>
    </g>
  </svg>
);

export default EditingScissors;
